import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './Card.module.scss';

function Card({ children, modifier, extraClasses = [] }) {
  return (
    <div className={classNames(styles.card, styles[modifier], extraClasses)}>
      <div className={styles.content}>{children}</div>
    </div>
  );
}

Card.propTypes = {
  children: PropTypes.element.isRequired,
  modifier: PropTypes.string,
  extraClasses: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
};

export default Card;
